import { getAPICall } from '../dataFetcher/axiosMethodCalls';
import { LOB_LIST, UnifiedCartItems } from '../context/reducer';

let unifiedCartResponse: Promise<UnifiedCartItems> | null = null;

let unifiedViewCartPushed = false;

export function shouldPushUnifiedViewCart(): boolean {
  if (unifiedViewCartPushed) {
    return false;
  }

  unifiedViewCartPushed = true;
  return true;
}

export function getUnifiedCartItems(
  idpToken: string | undefined,
  cachedItems?: UnifiedCartItems
): Promise<UnifiedCartItems> {
  if (cachedItems && LOB_LIST.every((lob) => cachedItems[lob] !== undefined)) {
    return Promise.resolve(cachedItems);
  }

  if (unifiedCartResponse) {
    return unifiedCartResponse;
  }

  unifiedCartResponse = Promise.all(
    LOB_LIST.map(async (lob) => {
      const response = await getAPICall(`${process.env.REACT_APP_CART_URL}/cartOrder?lob=${lob}`, {
        headers: { 'B2C-Authorization': idpToken },
      });

      return {
        lob,
        items: response?.data?.items ?? [],
        orderId: response?.data?.orderId ?? '',
      };
    })
  )
    .then(
      (carts) =>
        Object.fromEntries(carts.map(({ lob, ...cart }) => [lob, cart])) as UnifiedCartItems
    )
    .catch((error) => {
      unifiedCartResponse = null;
      throw error;
    });

  return unifiedCartResponse;
}
